import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius16,
  boxShadow815Grey,
} from 'approot/shared/styles/borders.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

export const ColourPickerPanel = styled.div`
  ${boxShadow815Grey}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing8)};
  max-width: ${rem(128)};
  width: 100%;
`;

export const ColourPickerPanelInner = styled(Box).attrs({
  $gap: spacing8,
})`
  height: 100%;
`;
